import { render, staticRenderFns } from "./insertUsersOpeningBalance.vue?vue&type=template&id=3fc1dfa4"
import script from "./insertUsersOpeningBalance.vue?vue&type=script&lang=js"
export * from "./insertUsersOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./insertUsersOpeningBalance.vue?vue&type=style&index=0&id=3fc1dfa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports